




























































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class EditReportSheetInfo extends Vue {
  @Prop() reportSheet!: any;
}
